import { useEffect, useState } from "react";

/**
 * Counts from 0 to `to` once, on mount. Respects prefers-reduced-motion (shows the final value).
 * Render the final number in a visually hidden element too, so crawlers and screen readers never see a half-way value.
 */
export function useCountUp(to, duration = 1400) {
  const reduce =
    typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const [value, setValue] = useState(reduce ? to : 0);

  useEffect(() => {
    if (reduce) return undefined;
    let frame;
    let start = null;
    const step = (t) => {
      if (start === null) start = t;
      const p = Math.min((t - start) / duration, 1);
      setValue(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [to, duration, reduce]);

  return value;
}
